import React, { useState } from 'react';
import Drawer from './Drawer';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Search from './Search';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import library from './Icons';
const queryString = require("query-string");

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
});

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            drawer: false
        };
        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    toggleDrawer = (state) => {
        this.props.toggleMenu(false);
        this.setState({ drawer: state });
    }

    render() {
        const { classes, showMenu, selectedVideo, selectVideo, allowAdmin, adminByQueryString, animateTransition, JWTToken } = this.props;
        const { drawer } = this.state;
        return (
            <div>
                <Drawer updateMenu={this.props.updateMenu} menu={this.props.menu} filteredMenu={this.props.filteredMenu} setFilteredMenu={this.props.setFilteredMenu} selectedVideo={selectedVideo} selectVideo={this.props.selectVideo} open={showMenu} toggleMenu={this.props.toggleMenu} toggleDrawer={this.toggleDrawer} />
                <div className={classes.root}>
                    <AppBar position="fixed" style={{ backgroundColor: 'black' }}>
                        <Toolbar className="navigation">
                            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                                <MenuIcon className={selectedVideo ? "" : "blob white"} onClick={() => this.props.toggleMenu(!drawer)} />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}><Link to={process.env.PUBLIC_URL + "/"} onClick={() => this.props.history.location.pathname !== process.env.PUBLIC_URL + "/" ? animateTransition("welcome") : true} style={{ color: "inherit", textDecoration: "none" }}>Entrenamiento Moodle</Link></Typography>
                            {
                                "admin" in queryString.parse(this.props.location.search) || adminByQueryString || JWTToken ?
                                    adminByQueryString || JWTToken ?
                                        <div>
                                            <Link to={process.env.PUBLIC_URL + "/admin"} onClick={() => this.props.history.location.pathname !== process.env.PUBLIC_URL + "/admin" ? animateTransition("login") : true} style={{ color: "inherit", textDecoration: "none" }}>
                                                <IconButton
                                                    aria-label="account of current user"
                                                    aria-controls="menu-appbar"
                                                    aria-haspopup="true"
                                                    color="inherit"
                                                >
                                                    <FontAwesomeIcon icon={"user-shield"} />
                                                </IconButton>
                                            </Link>
                                            <Menu
                                                id="menu-appbar"
                                                //anchorEl={anchorEl}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                keepMounted
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={false}
                                            //onClose={handleClose}
                                            >
                                                {/*<MenuItem onClick={handleClose}>Profile</MenuItem>
                                 <MenuItem onClick={handleClose}>My account</MenuItem>*/}
                                            </Menu>
                                        </div>


                                        : allowAdmin()

                                    :
                                    ""
                            }
                        </Toolbar>
                    </AppBar>
                </div>
                <div>{this.props.children}</div>
            </div>
        )
    }
};

export default withRouter((withStyles(styles)(Layout)));